module.exports = __webpack_public_path__ + "img/grid.cf62bc10.svg";